'use strict';

exports['default'] = {
  name: 'image-card',
  type: 'text',
  render: function render() {}
};